import React, { Component } from "react";
import { Button, CircularProgress } from "@material-ui/core";
import * as XLSX from 'xlsx'

export default class SubirProductos extends Component {
  constructor(props) {
    super(props);
    this.state = { fileUploadState: "", loading: false };
    this.inputReference = React.createRef();
  }

  fileUploadAction = () => {
    this.inputReference.current.click();
  };

  fileUploadInputChange = (e) => {
    this.setState({ fileUploadState: e.target.value, loading: true });
    let reader = new FileReader();
    let productos = [];
    const file = e.target.files;
    if (!file) {
      this.props.onChange([]);
    }
    reader.readAsArrayBuffer(file[0]);
    reader.onloadend = async (e) => {
      const data = new Uint8Array(e.target.result);
      var workbook = XLSX.read(data, { type: 'array' });
      for (const sheetName of workbook.SheetNames) {
        if (sheetName === 'Data' || sheetName === 'Sheet1' || sheetName === 'Layout') {
          const XL_row_object = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName])
          productos = XL_row_object.map(row => ({ 
            producto_clave: row['PRODUCTO_SAT'],
            clave_unidad: row['UNIDAD_MED_SAT'],
            descripcion: row['DESCRIPCION'],
            peso: row['PESO_PROD'],
            cantidad: row['CANT'],
            g_folio: row['GUIA'],
            SectorCOFEPRIS: row['SectorCOFEPRIS'],
            NombreIngredienteActivo: row['NombreIngredienteActivo'],
            NomQuimico: row['NomQuimico'],
            DenominacionGenericaProd: row['DenominacionGenericaProd'],
            DenominacionDistintivaProd: row['DenominacionDistintivaProd'],
            Fabricante: row['Fabricante'],
            FechaCaducidad: row['FechaCaducidad'],
            LoteMedicamento: row['LoteMedicamento'],
            FormaFarmaceutica: row['FormaFarmaceutica'],
            CondicionesEspTransp: row['CondicionesEspTransp'],
            RegistroSanitarioFolioAutorizacion: row['RegistroSanitarioFolioAutorizacion'],
            PermisoImportacion: row['PermisoImportacion'],
            FolioImpoVUCEM: row['FolioImpoVUCEM'],
            NumCAS: row['NumCAS'],
            RazonSocialEmpImp: row['RazonSocialEmpImp'],
            NumRegSanPlagCOFEPRIS: row['NumRegSanPlagCOFEPRIS'],
            DatosFabricante: row['DatosFabricante'],
            DatosFormulador: row['DatosFormulador'],
            DatosMaquilador: row['DatosMaquilador'],
            UsoAutorizado: row['UsoAutorizado'],
            TipoMateria: row['TipoMateria'],
            DescripcionMateria: row['DescripcionMateria'],
            ValorMercancia: row['ValorMercancia'],
          })).filter(row => !!row.producto_clave);
          this.props.onChange(productos);
        }
      }
      this.setState({
        loading: false
      });
    }
  }

  render() {
    const { loading } = this.state;
    return (
      <div>
        <input
          type="file"
          hidden
          ref={this.inputReference}
          onChange={this.fileUploadInputChange}
        />
        <Button disabled={loading} onClick={this.fileUploadAction} color="secondary" variant="outlined">
          {
            loading && (
              <CircularProgress color="secondary" size={20} />
            )
          }
          Subir Archivo (xlsx)
        </Button>
      </div>
    );
  }
}
